// extracted by mini-css-extract-plugin
export default {"close":"CloseButton_close__mZTAV","close--disabled":"CloseButton_close--disabled__wCF+M","close__icon":"CloseButton_close__icon__ZuEsO"};